<template>
    <div id="body">
        <b-container>
            <div class="box-tutorial">
                <img src="@/assets/ver2/tutorial.png" alt="">
                
            </div>
            <div class="box-button">
                <img @click="$TestApp.Start()" class="button-start" src="@/assets/ver2/start_tutorial.png" alt="">
                <!-- <img class="button-support" src="@/assets/ver2/support_tutorial.png" alt=""> -->
            </div>
            <div class="box-decor">
                <img class="img-human-left" src="@/assets/ver2/human-left.png">
                <img class="img-decor-paper" src="@/assets/ver2/decor_paper.png">
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
    
    components: {
        
    },
    computed: {
       
    },
    data () {
        return {
        }
    },
    watch: {
    },
    methods: {
       
    },
    created() {
    }
}
</script>
<style lang="scss" scoped>
    .box-tutorial {
        text-align: center;
        margin-top: 4rem;
        img{
            max-width: 48rem;
        }
    }
    .box-button {
        text-align: center;
        position: relative;
        top: -1.5rem;
        z-index: 1000;
        .button-start, .button-support {
            position: relative;
            cursor: pointer
        }
        .button-support{
            max-width: 10rem;
            left: 4rem;
            top: 0.5rem;
        }
        .button-start {
            max-width: 11rem;
            left: 2rem;
        }
    }
    .box-decor {
        position: relative;
        top: -16rem;
        .img-human-left {
            position: relative;
            max-width: 28rem;
            left: -2rem;
        }
        .img-decor-paper {  
            max-width: 23rem;
            right: -28rem;
            position: relative;
            top: 4rem;
        }
    }
    @media (min-width: 993px) and (max-width: 1200px) {
        .box-decor {
            top: -13rem;
        
            .img-human-left {
                max-width: 18rem;
                left: -5rem;
            }
            .img-decor-paper {  
                right: -27rem;
                top: 2rem;
                max-width: 18rem;
            }
        }
       
    }
    @media (min-width: 1201px) and (max-width: 1400px) {
        .box-decor {
            
            .img-human-left {
                max-width: 22rem;
                left: -2rem;
            }
            .img-decor-paper {  
                max-width: 19rem;
                right: -29rem;
            }
        }
    }
</style>